const badges = [
  {
    id: 1,
    name: 'Newcomer',
    description: 'Capai level 2',
    image: require('@/assets/badges/newcomer.png'),
    reward: 5,
    acquired: false,
  },
  {
    id: 2,
    name: 'Apprentice',
    description: 'Capai level 5',
    image: require('@/assets/badges/apprentice.png'),
    reward: 10,
    acquired: false,
  },
  {
    id: 3,
    name: 'Trained',
    description: 'Capai level 10',
    image: require('@/assets/badges/trained.png'),
    reward: 20,
    acquired: false,
  },
  {
    id: 4,
    name: 'A New Challenger',
    description: 'Dapatkan 10 performance point',
    image: require('@/assets/badges/a-new-challenger.png'),
    reward: 10,
    acquired: false,
  },
  {
    id: 5,
    name: 'Challenge Accepted!',
    description: 'Dapatkan 25 performance point',
    image: require('@/assets/badges/challenge-accepted.png'),
    reward: 20,
    acquired: false,
  },
  {
    id: 6,
    name: 'Champion',
    description: 'Dapatkan 50 performance point',
    image: require('@/assets/badges/champion.png'),
    reward: 40,
    acquired: false,
  },
  {
    id: 7,
    name: 'Lessoner',
    description: 'Selesaikan lima lesson',
    image: require('@/assets/badges/lessoner.png'),
    reward: 10,
    acquired: false,
  },
  {
    id: 8,
    name: 'Advanced Lessoner',
    description: 'Selesaikan salah satu lesson di kategori "Tingkat Lanjut"',
    image: require('@/assets/badges/advanced-lessoner.png'),
    reward: 10,
    acquired: false,
  },
  {
    id: 9,
    name: '1000% sure',
    description: 'Dapatkan total skor 1000.00%',
    image: require('@/assets/badges/1000.png'),
    reward: 20,
    acquired: false,
  },
]

export default badges